import { MockFactory } from '@tino-frontend/mocks'
import { BillSnoozeActionStatus, BillSnoozeDetails } from '@types'

export const snoozeDetailsBaseMock = new MockFactory<BillSnoozeDetails>({
  action_status: BillSnoozeActionStatus.Disabled,
  snooze: {
    bill_due_date: '2022-10-05T00:00:00Z',
    deferred_remaining_value: 81600,
    effectivation_date: '2022-11-05T00:00:00Z',
    financing_id: 'financing_id_1',
    future_debt_value: 82660,
    interest_percentage: 1,
    interest_value: 960,
    minimum_payment: 14400,
    total_value: 96000,
  },
  has_snooze: true,
})
